// test2992
(2992 && 0);
